"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushes = exports.steps = exports.duration = exports.climb = exports.distanceInMeters = exports.distance = exports.points = void 0;

var _conditions = require("./conditions");

var _convertDistance2 = _interopRequireDefault(require("../../char/convertDistance"));

var _formatNumber = _interopRequireDefault(require("../../char/formatNumber"));

var _getFormattedDuration = _interopRequireDefault(require("../../date/getFormattedDuration"));

var getDistance = function getDistance(_ref) {
  var distance = _ref.distance,
      locale = _ref.locale,
      _ref$unity = _ref.unity,
      unity = _ref$unity === void 0 ? 'km' : _ref$unity,
      measurementSystem = _ref.measurementSystem,
      _ref$maximumFractionD = _ref.maximumFractionDigits,
      maximumFractionDigits = _ref$maximumFractionD === void 0 ? 2 : _ref$maximumFractionD;

  var _convertDistance = (0, _convertDistance2["default"])(distance, {
    from: 'm',
    to: unity,
    toMeasurementSystem: measurementSystem
  }),
      value = _convertDistance.value,
      unit = _convertDistance.unit;

  return "".concat((0, _formatNumber["default"])(value, {
    locale: locale,
    maximumFractionDigits: maximumFractionDigits
  }), " ").concat(unit);
};

var points = function points(_ref2) {
  var points = _ref2.activity.points,
      displayPoint = _ref2.displayPoint,
      t = _ref2.t;
  return displayPoint ? {
    title: t('user.points'),
    points: points
  } : undefined;
};

exports.points = points;

var distance = function distance(_ref3) {
  var distance = _ref3.activity.distance,
      t = _ref3.t,
      locale = _ref3.locale,
      measurementSystem = _ref3.measurementSystem;
  return {
    title: t('dsn-ui.activity.detail.distance'),
    value: getDistance({
      distance: distance,
      locale: locale,
      measurementSystem: measurementSystem,
      unity: 'km'
    })
  };
};

exports.distance = distance;

var distanceInMeters = function distanceInMeters(_ref4) {
  var distance = _ref4.activity.distance,
      t = _ref4.t,
      locale = _ref4.locale,
      measurementSystem = _ref4.measurementSystem;
  return {
    title: t('dsn-ui.activity.detail.distance'),
    value: getDistance({
      distance: distance,
      locale: locale,
      measurementSystem: measurementSystem,
      unity: 'm'
    })
  };
};

exports.distanceInMeters = distanceInMeters;

var climb = function climb(_ref5) {
  var activity = _ref5.activity,
      climb = _ref5.activity.climb,
      t = _ref5.t,
      locale = _ref5.locale,
      measurementSystem = _ref5.measurementSystem;
  return (0, _conditions.hasClimb)({
    activity: activity,
    t: t,
    locale: locale
  }) ? {
    title: t('dsn-ui.activity.detail.climb'),
    value: getDistance({
      distance: climb,
      unity: 'm',
      locale: locale,
      measurementSystem: measurementSystem
    })
  } : undefined;
};

exports.climb = climb;

var duration = function duration(_ref6) {
  var duration = _ref6.activity.duration,
      t = _ref6.t,
      _ref6$durationFormat = _ref6.durationFormat,
      durationFormat = _ref6$durationFormat === void 0 ? t('dsn-ui.duration.format') : _ref6$durationFormat,
      trim = _ref6.trim,
      usePlural = _ref6.usePlural;
  return {
    title: t('dsn-ui.activity.detail.duration'),
    value: (0, _getFormattedDuration["default"])({
      duration: duration,
      format: durationFormat,
      trim: trim,
      unneededStart: t('dsn-ui.duration.unneeded-start'),
      usePlural: usePlural
    })
  };
};

exports.duration = duration;

var steps = function steps(_ref7) {
  var steps = _ref7.activity.steps,
      t = _ref7.t,
      locale = _ref7.locale;
  return {
    title: t('dsn-ui.activity.detail.steps'),
    value: "".concat((0, _formatNumber["default"])(steps, {
      locale: locale
    }), " ").concat(t('dsn-ui.activity.detail.steps').toLowerCase())
  };
};

exports.steps = steps;

var pushes = function pushes(_ref8) {
  var pushes = _ref8.activity.steps,
      t = _ref8.t,
      locale = _ref8.locale;
  return {
    title: t('dsn-ui.activity.detail.pushes'),
    value: "".concat((0, _formatNumber["default"])(pushes, {
      locale: locale
    }), " ").concat(t('dsn-ui.activity.detail.pushes').toLowerCase())
  };
};

exports.pushes = pushes;
//# sourceMappingURL=displayers.js.map